import get from 'lodash/get';

export function selectFlattenedAccount(account) {
  const {
    primary_color,
    accent_color,
    body_color,
    ...customizableFields
  } = get(account, 'processed_theme_options', {});
  return {
    bodyColor: body_color,
    customMessage: get(account, 'catering_general_settings.custom_message'),
    googleAnalytics4Code: get(
      account,
      'google_analytics_browser.measurement_id',
      ''
    ),
    heroImage: get(
      account,
      'catering_general_settings.store_header_image[0]',
      {}
    ),
    logo: get(account, 'catering_general_settings.logo[0].url', account.logo),
    logoDestinationUrl: get(
      account,
      'catering_general_settings.logo_destination_url'
    ),
    name: account.name,
    primaryColor: primary_color,
    secondaryColor: accent_color,
    utmFooterLink: get(account, 'utm_footer_link'),
    betaFeatureFlags: get(account, 'beta_feature_flags'),
    storeTemporarilyDisabled: get(account, 'store_temporarily_disabled'),
    displayLocationInformationOnLayout: get(
      account,
      'catering_general_settings.display_location_information_on_layout'
    ),
    selfHostedFonts: get(account, 'selfhosted_fonts', []),
    customizableFields,
    facebookPixelId: get(account, 'facebook_pixel_id')
  };
}
